<template>
  <app-page-container :showNav="true">
    <div class="changelog">
      <div class="changelog-header">
        <div class="changelog-title">Changelog</div>
      </div>
      <div class="changelog-entries">
        <div class="changelog-entry">
          <div class="changelog-meta">
            <div class="changelog-version">v1.00.00</div>
            <div class="changelog-date">July 29, 2021</div>
          </div>
          <div class="changelog-content">
            <div class="changelog-entry-title">
              ✨ Robert Is Going to Tunis! ✈️
            </div>
            <div class="changelog-text">
              Can you believe it? It's true. It's happening.
              <img
                src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-07-29_at_21.48.40_dh9y-TOAll.png"
                class="changelog-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-page-container>
</template>

<script>
/** Can add:
 * Tip section
 * Important to know
 * Emoji picker
 */
import AppPageContainer from "@/components/AppPageContainer";

export default {
  name: "Changelog",
  components: {
    AppPageContainer,
  },
  data() {
    return {
      changelogs: [
        {
          version: "v1.00.00",
          date: "July 29, 2021",
          title: "✨ Robert Is Going to Tunis! ✈️",
          featuredImage: "",
          abstract: "",
          sections: [
            {
              type: "paragraph",
              content: "Can you believe it? It's true. It's happening.",
            },
            {
              type: "image",
              content:
                "https://ik.imagekit.io/elysiumone/Screen_Shot_2021-07-29_at_21.48.40_dh9y-TOAll.png",
            },
          ],
          new: [
            {
              text: "",
              visual: "", // gif or image, optional
            },
          ],
          improvements: [],
          fixes: [],
        },
      ],
    };
  },
};
</script>

<style scoped>
.changelog {
  min-width: 720px;
  max-width: 860px;
  margin: 0 auto;
  box-sizing: border-box;
}
.changelog-header {
  padding: 60px 0px 80px;
  margin-left: 220px;
}
.changelog-title {
  font-size: 48px;
  font-weight: 600;
}
.changelog-entry {
  display: flex;
}
.changelog-entry-title {
  font-size: 34px;
  font-weight: 600;
  padding-bottom: 20px;
}
.changelog-content {
  width: calc(860px - 220px);
  box-sizing: border-box;
}
.changelog-meta {
  width: 220px;
  box-sizing: border-box;
}
.changelog-version {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: inherit;
  padding: 4px 16px;
  border-radius: 6px;
  background-color: #e2ebff;
  color: #4d50d4;
  font-weight: 600;
}
.changelog-text {
  font-size: 18px;
  line-height: 28px;
}
.changelog-date {
  padding: 12px 0px;
  font-size: 17px;
}
.changelog-image {
  width: calc(860px - 220px);
  border-radius: 6px;
  margin: 14px 5px;
  box-shadow: 0px 1px 4px 0 #afafaf57;
}
</style>